import { lotFromFirestore } from '@parallel-fluidics/shared/models/lots';
import {
  collection,
  documentId,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

/** Fetch lots by doc IDs in chunked documentId-in queries. */
export default async function fetchLotsByIds(lotIds) {
  const chunkSize = 30; // Firestore 'in' queries support up to 30 values
  const chunks = [];
  for (let i = 0; i < lotIds.length; i += chunkSize) {
    chunks.push(lotIds.slice(i, i + chunkSize));
  }
  const lots = [];
  await Promise.all(chunks.map(async (chunk) => {
    const snapshot = await getDocs(query(
      collection(getFirestore(), 'lots'),
      where(documentId(), 'in', chunk),
    ));
    snapshot.docs.forEach((lotDoc) => lots.push(lotFromFirestore(lotDoc)));
  }));
  return lots;
}
